import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { solutions, solutionOrder } from './solutionsData';
import './Solutions.css';

const toId = (s) => s.toLowerCase().replace(/[\s&]+/g, '-');

const Solutions = () => {
  const reduced = useReducedMotion();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fade = {
    hidden: { opacity: 0, y: reduced ? 0 : 22 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: reduced ? 0.2 : 0.6, delay: reduced ? 0 : i * 0.08, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  return (
    <div className="sol-page">
      <section className="sol-hero">
        <div className="sol-hero-glow" aria-hidden="true" />
        <motion.h1 className="sol-hero-title" initial="hidden" animate="visible" variants={fade}>
          The right agent for your industry, your workflow, your stack.
        </motion.h1>
        <motion.p className="sol-hero-sub" initial="hidden" animate="visible" variants={fade} custom={1}>
          Whatever your vertical or use case, we've designed agents for it — and we can build something
          entirely custom if your needs go beyond the standard playbook. Scope, build, ship.
        </motion.p>
      </section>

      <section className="sol-list">
        {solutionOrder.map((slug, i) => {
          const s = solutions[slug];
          const Icon = s.icon;
          return (
            <motion.div
              key={slug}
              className="sol-row"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-80px' }}
              variants={fade}
            >
              <div className="sol-row-head">
                <div className="sol-row-icon"><Icon size={24} /></div>
                <span className="sol-row-eyebrow">{s.eyebrow}</span>
              </div>
              <div className="sol-row-body">
                <h2 className="sol-row-title">{s.title}</h2>
                <p className="sol-row-sub">{s.subtitle}</p>
                <div className="sol-row-chips">
                  {s.integrations.slice(0, 5).map((c) => (
                    <span key={c} className="sol-chip">{c}</span>
                  ))}
                </div>
                {s.industries && (
                  <div className="sol-row-industries">
                    {s.industries.map((ind) => (
                      <Link
                        key={ind}
                        to={`/use-cases#${toId(ind)}`}
                        className="sol-ind-chip"
                      >
                        {ind}
                      </Link>
                    ))}
                  </div>
                )}
                <Link to={`/solutions/${slug}`} className="sol-row-link">
                  Learn more <ArrowRight size={16} />
                </Link>
              </div>
            </motion.div>
          );
        })}
      </section>

      <section className="sol-cta">
        <div className="sol-cta-glow" aria-hidden="true" />
        <h2>Not sure which agent you need?</h2>
        <p>Tell us the problem. We'll tell you what to build — and scope it in 24 hours.</p>
        <Link to="/contact" className="btn-primary">
          Book a Scoping Call <ArrowRight size={18} />
        </Link>
      </section>
    </div>
  );
};

export default Solutions;
